module.exports = __webpack_public_path__ + "static/media/realtors-icon-3.92f86cab.svg";